import { ValueType } from "@/enums/ValueType";

export const nhgKostengrens = {
	metadata: {
		type: ValueType.Currency,
	},
	values: {
		"2002-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/zhgfyhvu/jaarverslag_2001_en_liquiditeitsprognose_2002-2007.pdf",
			},
			value: 200_000,
		},
		"2003-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/jd2bhpmt/jaarverslag_2003_en_liquiditeitsprognose_2004-2009.pdf",
			},
			value: 225_000,
		},
		"2004-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/l2pfcnmc/jaarverslag_2004_en_liquiditeitsprognose_2005-2010.pdf",
			},
			value: 230_000,
		},
		"2005-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/l2pfcnmc/jaarverslag_2004_en_liquiditeitsprognose_2005-2010.pdf",
			},
			value: 240_000,
		},
		"2006-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/i0jkdldo/jaarverslag_2005_en_liquiditeitsprognose_2006-2011.pdf",
			},
			value: 250_000,
		},
		"2007-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/lmdb3tdv/jaarverslag_2006_en_liquiditeitsprognose_2007-2012.pdf",
			},
			value: 265_000,
		},
		"2009-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/isils5ia/voorwaarden_en_normen_2009-i.pdf",
			},
			value: 265_000,
		},
		"2009-07-01": {
			metadata: {
				reference:
					"https://weblog.independer.nl/productnieuws/kosten-nationale-hypotheekgarantie-in-2010-omhoog/",
			},
			value: 350_000,
		},
		"2012-07-01": {
			metadata: {
				reference: "https://www.nhg.nl/media/rtkfvrim/toelichting-2012-2.pdf",
			},
			value: 320_000,
		},
		"2014-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/3mljj1zp/voorwaarden_en_normen_2014-1_1__1_november_2013.pdf",
			},
			value: 290_000,
		},
		"2015-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/cdnf0ham/voorwaarden_en_normen_2015-2.pdf",
			},
			value: 265_000,
		},
		"2016-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/archief-nieuwsberichten/nhg-kostengrens-blijft-245-000/",
			},
			value: 245_000,
		},
		"2017-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/archief-nieuwsberichten/nhg-kostengrens-vanaf-1-januari-2017/",
			},
			value: 247_000,
		},
		"2018-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/archief-nieuwsberichten/kostengrens-nhg-stijgt-ruim-8-procent/",
			},
			value: 265_000,
		},
		"2019-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/archief-nieuwsberichten/nieuwe-kostengrens-nhg/",
			},
			value: 290_000,
		},
		"2020-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/archief-nieuwsberichten/kostengrens-in-2020-naar-310-000/",
			},
			value: 310_000,
		},
		"2021-01-01": {
			metadata: {
				reference: "https://www.nhg.nl/media/1o3fihr2/vn-2021-2-def.pdf",
			},
			value: 325_000,
		},
		"2022-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/3msldahp/19102022-incl-nibud-def-vn-2022-01-2.pdf",
			},
			value: 355_000,
		},
		"2023-01-01": {
			metatdata: {
				reference:
					"https://www.nhg.nl/media/vi5cwsps/vn-2023-01-def-met-tabellen-en-tr.pdf",
			},
			value: 405_000,
		},
		"2024-01-01": {
			metatdata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/nhg-grens-stijgt-naar-435-000-in-2024-provisie-blijft-0-6/",
			},
			value: 435_000,
		},
		"2025-01-01": {
			metatdata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/nieuwe-voorwaarden-en-normen-in-2025/",
			},
			value: 450_000,
		},
		"2026-01-01": {
			metatdata: {
				reference:
					"https://www.rijksoverheid.nl/actueel/nieuws/2025/10/08/nhg-grens-stijgt-naar-%E2%82%AC-470.000-euro-afsluitpremie-blijft-04",
			},
			value: 470_000,
		},
	},
};
